module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/git-4-38d7f056ac829478e83c2c2dd81de47b.svg";